// Tolka en lista med lärare — inklistrad från Excel eller uppladdad som fil —
// till rader { name, email, lu_id }.
//
// Med rubrikrad (Namn / E-post / LU-id, i valfri ordning) används rubrikerna.
// Utan rubriker gissas kolumnerna per cell: en adress med @ är e-post, ett
// ord utan mellanslag med siffror (som ett Lucat-id) är LU-id, resten namn.

const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const HEADER = {
  name: /^(namn|name|fullständigt namn|full name)$/i,
  email: /^(e-?post|e-?mail|mejl|mail|e-?postadress|epostadress)$/i,
  lu_id: /^(lu-?id|lucat(-?id)?|användarnamn|anv\.?namn|username)$/i,
};

// Text → rader av celler. Tabb först (så kommer det från Excel), annars ; eller ,
export function splitText(text) {
  const lines = String(text || "").split(/\r?\n/).map(l => l.trim()).filter(Boolean);
  return lines.map(line => {
    const sep = line.includes("\t") ? "\t" : line.includes(";") ? ";" : ",";
    return line.split(sep).map(c => c.trim());
  });
}

function headerMap(cells) {
  const map = {};
  cells.forEach((c, i) => {
    for (const [field, rx] of Object.entries(HEADER)) if (rx.test(String(c).trim())) map[field] = i;
  });
  return Object.keys(map).length >= 1 && (map.email !== undefined || map.lu_id !== undefined) ? map : null;
}

function looksLikeLuId(s) {
  return /^[a-z0-9._-]{4,}$/i.test(s) && /\d/.test(s) && !s.includes("@");
}

function guessRow(cells) {
  const row = { name: "", email: "", lu_id: "" };
  const rest = [];
  for (const raw of cells) {
    const c = String(raw ?? "").trim();
    if (!c) continue;
    if (!row.email && EMAIL_RX.test(c)) row.email = c;
    else if (!row.lu_id && looksLikeLuId(c)) row.lu_id = c;
    else rest.push(c);
  }
  row.name = rest.join(" ");
  return row;
}

// Rader av celler (från text eller kalkylblad) → { rows, usedHeader }
export function parseUserRows(table) {
  const rows = (table || []).filter(r => Array.isArray(r) && r.some(c => String(c ?? "").trim()));
  if (rows.length === 0) return { rows: [], usedHeader: false };
  const map = headerMap(rows[0]);
  const body = map ? rows.slice(1) : rows;
  const out = body.map(cells => {
    if (!map) return guessRow(cells);
    const at = i => (i === undefined ? "" : String(cells[i] ?? "").trim());
    return { name: at(map.name), email: at(map.email), lu_id: at(map.lu_id) };
  }).map(r => ({ ...r, email: r.email.toLowerCase(), lu_id: r.lu_id.toLowerCase() }))
    .filter(r => r.name || r.email || r.lu_id);
  // Samma person två gånger i listan räcker en gång
  const seen = new Set();
  const unique = out.filter(r => {
    const k = r.email || r.lu_id || r.name;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
  return { rows: unique, usedHeader: !!map };
}

// Inloggning sker med LU-konto. En adress utanför LU går bara att koppla till
// kontot om LU-id också anges — annars får läraren ett konto utan behörighet.
export function isLuAddress(email) {
  const domain = String(email || "").split("@")[1] || "";
  return domain === "lu.se" || domain.endsWith(".lu.se");
}

export function rowProblem(r) {
  if (r.email && !EMAIL_RX.test(r.email)) return "invalid_email";
  if (!r.email && !r.lu_id) return "missing";
  if (r.email && !isLuAddress(r.email) && !r.lu_id) return "needs_lu_id";
  return null;
}
